<template>
	<AppHeader
		:logo="logo"
		:headerButton1="headerButton1"
		:headerButton2="headerButton2"
		hideBtn1
	/>

	<div class="flex-grow-1">
		<UiElement class="d-flex flex-column h-100 py-0" :settings="appearance.body.settings">
			<UiText :settings="text1" class="text-center" content="3/3">
			</UiText>

			<UiText :settings="heading1" class="text-center" :content="translations?.payment || '{payment}'">
			</UiText>

			<div class="d-flex flex-column align-items-center flex-grow-1" style="margin-top:237px">
				<UiText :settings="heading1" class="text-center" :content="translations?.paymentTitle || '{paymentTitle}'">
				</UiText>

				<UiElement :settings="arrow" class="d-flex align-items-center justify-content-center">
					<img v-if="elements?.arrow?.settings?.image" :src="elements.arrow.settings.image" alt="" class="w-100" />

					<img v-else src="/images/Arrow.png" alt="" class="w-100" />
				</UiElement>

				<div class="w-100">
					<UiProgress :settings="general.elements.progress1.settings" :progress="50" animation="slide" />
				</div>
			</div>
		</UiElement>
	</div>
</template>

<script setup>
	import { computed, onMounted, watch } from 'vue';
	import { storeToRefs } from 'pinia';
	import { useRouter } from 'vue-router';

	import { useInheritedSettings } from '@/composables/useInheritedSettings';
	import { useKioskRoute } from '@/composables/useKioskRoute';

	import { useLegacyKioskStore as useKioskStore, useLegacyKioskStore } from '@/stores/legacy/kiosk-store';
	import { useTranslationsStore } from '@/stores/useTranslationsStore';
	import { useBasketStore } from '@/stores/legacy/basket-store';
	import { useThemeStore } from '@/stores/useThemeStore';
	import { useOrderStore } from '@/stores/useOrderStore';

	import UiElement from '@/components/UI/UiElement.vue';
	import UiText from '@/components/UI/UiText.vue';
	import UiProgress from '@/components/UI/UiProgress.vue';
	import AppHeader from '@/components/AppHeader.vue';
	import { useIdleStore } from '@/stores/useIdleStore';

	const orderStore = useOrderStore();
	const { makePath } = useKioskRoute();
	const router = useRouter();
	const { cart, total, orderId } = storeToRefs(orderStore);

	const kiosk = useKioskStore();
	const themeStore = useThemeStore();
	const translationsStore = useTranslationsStore();

	const { theme } = storeToRefs(themeStore);
	const { translations } = storeToRefs(translationsStore);

	const general = computed(() => theme.value.general);
	const page = computed(() => theme.value.pages.payment);
	const appearance = computed(() => page.value.appearance);
	const elements = computed(() => page.value.elements);

	const text1 = useInheritedSettings(computed(() => elements.value?.text1));
	const heading1 = useInheritedSettings(computed(() => elements.value?.heading1));
	const arrow = useInheritedSettings(computed(() => elements.value?.arrow));

	const logo = useInheritedSettings(computed(() => elements.value?.logo));
	const headerButton1 = useInheritedSettings(computed(() => elements.value?.headerButton1));
	const headerButton2 = useInheritedSettings(computed(() => elements.value?.headerButton2));

	// PAYMENT STATUS
	const order = computed(() => {
		return {
			orderId: orderId.value,
			currency: kiosk?.currencyObject?.code || 'EUR',
			items: cart.value
		}
	});

	const basketStore = useBasketStore();
	const legacyKioskStore = useLegacyKioskStore();
	const { checkoutStatus, activeOrderId, paymentStatus } = storeToRefs(basketStore);
	const { paymentObject } = storeToRefs(basketStore);

	function goHome() {
		router.push(makePath('/'))
	}

	/* V - LEGACY - V */

	function parseCart(cart) {
		const flatMap = {};

		cart.forEach(item => {
			const mainKey = item.id;
			if (!flatMap[mainKey]) {
				flatMap[mainKey] = {
					...item,
					...item.details,
					amount: 0
				};

				delete flatMap[mainKey].details;
			}
			flatMap[mainKey].amount += item.amount;

			(item.modifiers || []).forEach(modifier => {
				const modKey = modifier.id;
				if (!flatMap[modKey]) {
					flatMap[modKey] = {
						ingredients: [],
						...modifier,
						id: modifier.id,
						label: modifier.name || modifier.label || 'Modifier',
						price: modifier.price || 0,
						amount: 0
					};
				}
				flatMap[modKey].amount += item.amount;
			});

			(item.notes || []).forEach(note => {
				const noteKey = note.id;
				if (!flatMap[noteKey]) {
					flatMap[noteKey] = {
						ingredients: [],
						...note,
						id: note.id,
						label: note.name || note.label || 'Ingredient',
						price: note.inMenuPrice || 0,
						amount: 0
					};
				}
				flatMap[noteKey].amount += item.amount;
			});
		});

		return Object.values(flatMap).map(item => {
			const { amount, ...rest } = item;

			const cleaned = { ...rest };
			delete cleaned.ingredients;
			delete cleaned.modifier;
			delete cleaned.allergens;
			delete cleaned.descriptions;

			return {
				...cleaned,
				quantity: amount
			};
		});
	}

	function paymentCC() {
		basketStore.$patch({
			paymentType: "creditcard"
		})

		// Platba
		// Open alert dialog
		basketStore.$patch({
			cardDialog: true
		})

		const orderNumber = orderId.value;
		const net = total.value / (1 + 0.21) // TODO: replace with real %

		const order = {
			orderId: orderNumber,
			// orderDetail: cart.value.map(item => parseIngredients(item.details)),
			orderDetail: parseCart(cart.value),
			net,
			vat: total.value - net,
			total: total.value
		}

		basketStore.insertNewOrder(order);
	}

	watch(checkoutStatus, (newVal) => {
		console.log("Septim resp 1", newVal);
		console.log("Septim resp 2", paymentStatus.value.lastId);
		// basketStore.septimOrderPaymentRequest(checkoutStatus.value);
		// router.push(makePath('/payment-complete'));
		// Tuto update DB
		if (newVal) {
			console.log("test");
			//TESTING NO PAY

			basketStore.updateOrder({ septimResponse: newVal });
			// Ak je chyba tak msg
			if (newVal.error) {
				// console.log('Routing to error page', newVal.error.message);
				// problem je ze vola aj dialog na platbu
				basketStore.$patch({
					statusDialog: false
				})
				// console.log(myDialog)
				router.push(makePath('/payment-failed'));
			}

		}
	});

	watch(paymentStatus, (newVal) => {
		console.log("paymentStatus: ", newVal);
		if (newVal) {
			if (newVal?.posModel && newVal.posModel === "ux410") {
				// POS Model UX410
				if (newVal.r === 0) {
					// Status 0 - Payed
					basketStore.$patch({
						alert: false,
						alertDialog: {
							title: 'payment',
							value: 'payDialogAccept' + ' ' + 'payDialogOrderNum ' + newVal.I,
							level: 'primary',
							button: false
						},
						cardDialog: false,
					});
					// Print
					basketStore.printReceipt(newVal.I, cart.value)

					router.push(makePath('/payment-complete'));

				} else if (newVal.r === 1) {
					console.log("Response 1: ", newVal);
					const errText = newVal.T
					// basketStore.setAlert(true, 'payment', 'payDialogDecline' + ' ' + errText)
					basketStore.$patch({
						alert: true,
						alertDialog: {
							title: 'payment',
							value: 'payDialogDecline' + ' ' + errText,
							level: 'negative',
							button: false
						}
					});
				} else if (newVal.r === 9) {
					console.log("Response 9: ", newVal);
					const errText = newVal.L
					// basketStore.setAlert(true, 'payment', 'payDialogError' + ' ' + errText)
					basketStore.$patch({
						alert: true,
						alertDialog: {
							title: 'payment',
							value: 'payDialogError' + ' ' + errText,
							level: 'negative',
							button: false
						}
					});
				} else {
					// basketStore.setAlert(false, null, null)
					basketStore.$patch({
						alert: false,
						alertDialog: {
							title: null,
							value: null,
							level: 'primary',
							button: false
						}
					});
				}
			}

			if (newVal?.posModel && newVal.posModel === "paxa920") {
				// POS Model PAX A920Pro
				if (newVal['12'] === 0) {
					console.log("Response 0, transaction rejected: ", newVal);
					const errText = newVal['14']

					basketStore.updateOrderStatus(6, errText, activeOrderId.value)
					// basketStore.setAlert(true, 'payment', 'payDialogError' + ' ' + errText)
					basketStore.$patch({
						alert: true,
						alertDialog: {
							title: 'payment',
							value: 'payDialogError' + ' ' + errText,
							level: 'negative',
							button: false
						},
						paymentType: null
					});

				} else if (newVal['12'] === 1) {
					console.log("Response 1, transaction completed: ", newVal);
					const errText = newVal['14']
					const oid = newVal['20'].slice(newVal['20'].length - 3)
					//
					basketStore.updateOrderStatus(1, errText, activeOrderId.value)
					// Print
					basketStore.printReceipt(oid, order.value)
					// Posle objednavku do systemu (Septim)
					// basketStore.septimOrder({ order: orderCC.value, payment: 'creditcard' })

					// Alert
					// basketStore.setAlert(true, 'payment', 'payDialogAccept' + ' ' + 'payDialogOrderNum' { n: oid }) + '\n\r' + errText)
					basketStore.$patch({
						alert: true,
						alertDialog: {
							title: 'payment',
							value: 'payDialogAccept' + ' ' + 'payDialogOrderNum ' + oid + '\n\r' + errText,
							level: 'negative',
							button: false
						},
						paymentType: null
					});

				} else if (newVal['12'] === 2) {
					console.log("Response 2, transaction approved part: ", newVal);
					const errText = newVal['14']

					basketStore.updateOrderStatus(2, errText, activeOrderId.value)
					// basketStore.setAlert(true, 'payment', errText)
					basketStore.$patch({
						alert: true,
						alertDialog: {
							title: 'payment',
							value: errText,
							level: 'negative',
							button: false
						},
						paymentType: null
					});
				} else {
					// basketStore.setAlert(false, null, null)
					basketStore.$patch({
						alert: false,
						alertDialog: {
							title: null,
							value: null,
							level: 'primary',
							button: false
						}
					});
				}

				console.log("TIME OUTED");
				goHome();

			}

			if (newVal?.posModel && newVal.posModel === "p400") {
				// POS Model Verifone P400
				for (const key in newVal) {
					if (Object.hasOwnProperty.call(newVal, key)) {
						// const el = newVal[key];
						if (key === 0) {
							console.log("Payment Approved, Response 0: ", newVal);

							const dTitle = newVal.T
							const expId = newVal.I.slice(6)

							basketStore.updateOrderStatus(1, dTitle)

							basketStore.$patch({
								alert: false,
								alertDialog: {
									title: dTitle,
									value: 'payDialogAccept' + ' ' + 'payDialogOrderNum ' + expId,
									level: 'primary',
									button: false
								},
								paymentType: null
							});

							androidPrint();

							if (legacyKioskStore.SEPTIM.ACTIVE === 'true') {
								console.log("Posiela do Septim ", checkoutStatus.value);
								basketStore.septimOrderPaymentRequest(checkoutStatus.value) //
							}

							router.push(makePath('/payment-complete'));

						} else if (key === 1) {
							console.log("Payment Declined by Host, Response 1: ", newVal);

							const errText = newVal.T
							// basketStore.setAlert(false, '', '')
							basketStore.$patch({
								alert: false,
								alertDialog: {
									title: 'payment',
									value: 'payDialogDecline',
									level: 'primary',
									button: false
								},
								paymentType: null
							});
							// Aby pri unmount uz nezapisal update statusu
							basketStore.updateOrderStatus(2, errText)

							router.push(makePath('/payment-failed'));
							// basketStore.setAlert(true, errText, 'payDialogDecline' + ' ' + errText)
						} else if (key === 3) {
							const errText = newVal.T
							basketStore.updateOrderStatus(3, errText)
							//status.value = 'Payment partially approved'
							console.log("TIME OUTED");
							// goHome();
							router.push(makePath('/payment-failed'));

						} else if (key === 9) {
							console.log("Payment Declined locally, Response 9: ", newVal);
							const errText = newVal.L
							basketStore.updateOrderStatus(5, errText)

							basketStore.$patch({
								alert: true,
								alertDialog: {
									title: 'payment',
									value: 'payDialogError' + ' ' + errText,
									level: 'negative',
									button: false
								},
								paymentType: null
							});

							console.log("TIME OUTED");
							//goHome();
							router.push(makePath('/payment-failed'));

						} else {
							// status.value = ''
						}
					}
				}
			}

			if (newVal?.posModel && newVal.posModel === "in3000") {
				const responseCode = parseInt(newVal.R)
				if (responseCode < 10) {
					console.log("Payment Approved, Response: ", newVal);

					basketStore.updateOrderStatus(1, newVal.S);

					basketStore.$patch({
						alert: false,
						alertDialog: {
							title: 'payment',
							value: 'payDialogAccept' + ' ' + 'payDialogOrderNum ' + newVal.n,
							level: 'primary',
							button: false
						},
						paymentType: null
					});

					// Android Print
					androidPrint();

					if (legacyKioskStore.SEPTIM.ACTIVE === 'true') {
						// Posle objednavku do systemu (Septim)
						// console.log("Posiela do Septim ", {...orderCC.value, ...{oid: newVal.S}}, orderTime.value);
						console.log("Posiela do Septim ", checkoutStatus.value);
						basketStore.septimOrderPaymentRequest(checkoutStatus.value)

					}

					router.push(makePath('/payment-complete'));

				} else {
					basketStore.septimOrderPaymentRequestFailed(checkoutStatus.value);
					router.push(makePath('/payment-failed'));
				}
				// else if (responseCode === 10) {
				// 	console.log("Partially Approved, Response: ", newVal);
				// } else {
				// 	console.log("Declined, Response: ", newVal);
				// 	let errText = '';
				//
				// 	switch (responseCode) {
				// 		case 50:
				// 			errText = 'General processing error';
				// 			break;
				// 		case 51:
				// 			errText = 'Unable to connect with Central Systems';
				// 			break;
				// 		case 53:
				// 			errText = 'A response from the Central System was not delivered';
				// 			break;
				// 		case 55:
				// 			errText = 'Declined by chip card without authorization';
				// 			break;
				// 		case 56:
				// 			errText = 'Declined by authorization host (online transaction)';
				// 			break;
				// 		case 60:
				// 			errText = 'Transaction was canceled by the operator';
				// 			break;
				// 		case 61:
				// 			errText = 'Transaction was canceled by the customer';
				// 			break;
				// 		case 62:
				// 			errText = 'Customer rejected transaction due to amount';
				// 			break;
				// 		case 63:
				// 			errText = 'Processing exceeded the designated time limit';
				// 			break;
				// 		case 70:
				// 			errText = 'Transaction was not canceled';
				// 			break;
				// 		case 71:
				// 			errText = 'Currency not supported (Multicurrency)';
				// 			break;
				// 		case 80:
				// 			errText = 'No paper in the internal printer';
				// 			break;
				// 		case 81:
				// 			errText = 'Reversal successful';
				// 			break;
				// 		case 82:
				// 			errText = 'Reversal successful. Reversal reason = Card removed too soon';
				// 			break;
				// 		case 100:
				// 			errText = 'Transaction not supported or not allowed';
				// 			break;
				// 		case 101:
				// 			errText = 'Invalid card';
				// 			break;
				// 		case 103:
				// 			errText = 'Error in message format (protocol error)';
				// 			break;
				// 		case 106:
				// 			errText = 'Error in message CRC (protocol error)';
				// 			break;
				// 		case 107:
				// 			errText = 'Error in MAC (protocol error)';
				// 			break;
				// 		case 108:
				// 			errText = 'Terminal Busy (protocol error)';
				// 			break;
				// 		case 110:
				// 			errText = 'The amount is not allowed';
				// 			break;
				// 		case 111:
				// 			errText = 'Transaction refused by terminal';
				// 			break;
				// 		case 160:
				// 			errText = 'Totals on ECR, POST are not equal, on AC completed (AC+POST)';
				// 			break;
				// 		case 161:
				// 			errText = 'Totals on ECR, POST are not equal, on AC not finished (POST without Response)';
				// 			break;
				// 		case 170:
				// 			errText = 'Transaction successfully aborted via Abort request (T12)';
				// 			break;
				// 		case 200:
				// 			errText = 'Mandatory field missing in request message';
				// 			break;
				// 		case 360:
				// 			errText = 'Repeat Last Message - origin message not found';
				// 			break;
				// 		case 500:
				// 			errText = 'Internal application Error';
				// 			break;
				// 		default:
				// 			break;
				// 	}
				//
				//
				// 	basketStore.updateOrderStatus(5, errText)
				//
				// 	basketStore.$patch({
				// 		alert: true,
				// 		alertDialog: {
				// 			title: 'payment',
				// 			value: 'payDialogError' + ' ' + errText,
				// 			level: 'negative',
				// 			button: false
				// 		},
				// 		paymentType: null
				// 	});
				//
				// 	// console.log("TIME OUTED");
				// 	//goHome();
				// 	router.push(makePath('/payment-failed'));
				//
				// }
			}

			if (newVal?.posModel && newVal.posModel === "sunmi_p2") {
				// {"result": "Success", "errorCondition": "", "cardNumber": "47##-####-####-4873", "aid": "A0000000031010", "sequenceNumber": "1234567890", "brand": "VISA", "method": "CLESS", "authorizationCode": "123456", "terminalId": "V3MIXTEST"}
				const result = newVal.result;
				if (result === 'Success') {
					// OK
					console.log("Payment Approved, Response: ", newVal);
					basketStore.updateOrderStatus(1, newVal.transactionId);

					basketStore.$patch({
						alert: false,
						alertDialog: {
							title: 'payment',
							value: 'payDialogAccept' + ' ' + 'payDialogOrderNum ' + newVal.transactionId,
							level: 'primary',
							button: false
						},
						paymentType: null
					});

					// Android Print
					androidPrint()

					if (legacyKioskStore.SEPTIM.ACTIVE === 'true') {
						// Posle objednavku do systemu (Septim)
						console.log("Posiela do Septim ", checkoutStatus.value);
						basketStore.septimOrderPaymentRequest(checkoutStatus.value)
					}

					router.push(makePath('/payment-complete'));
				} else {
					// Error
					console.log("Declined, Response: ", newVal);
					const errText = newVal.errorCondition;
					basketStore.updateOrderStatus(5, errText)

					basketStore.$patch({
						alert: true,
						alertDialog: {
							title: 'payment',
							value: 'payDialogError' + ' ' + errText,
							level: 'negative',
							button: false
						},
						paymentType: null
					});

					// console.log("TIME OUTED");
					goHome();
				}
			}

			if (newVal?.posModel && newVal.posModel === "gptom") {
				// {"result": "Success", "errorCondition": "", "cardNumber": "47##-####-####-4873", "aid": "A0000000031010", "sequenceNumber": "1234567890", "brand": "VISA", "method": "CLESS", "authorizationCode": "123456", "terminalId": "V3MIXTEST"}
				const result = newVal.result;
				if (result === 'Success') {
					// OK
					console.log("Payment Approved, Response: ", newVal);
					basketStore.updateOrderStatus(1, newVal.transactionId);

					basketStore.$patch({
						alert: false,
						alertDialog: {
							title: 'payment',
							value: 'payDialogAccept' + ' ' + 'payDialogOrderNum ' + newVal.transactionId,
							level: 'primary',
							button: false
						},
						paymentType: null
					});

					// Android Print
					androidPrint()

					if (legacyKioskStore.SEPTIM.ACTIVE === 'true') {
						// Posle objednavku do systemu (Septim)
						console.log("Posiela do Septim ", checkoutStatus.value);
						basketStore.septimOrderPaymentRequest(checkoutStatus.value)
					}

					router.push(makePath('/payment-complete'));
				} else {
					// Error
					console.log("Declined, Response: ", newVal);
					const errText = newVal.errorCondition;
					basketStore.updateOrderStatus(5, errText)

					basketStore.$patch({
						alert: true,
						alertDialog: {
							title: 'payment',
							value: 'payDialogError' + ' ' + errText,
							level: 'negative',
							button: false
						},
						paymentType: null
					});

					goHome();
				}
			}
		}
	});

	function androidPrint() {
		const print = {
			type: "print",
			response: paymentObject.value
		}
		basketStore.printTransaction(print)
		// socket.send(JSON.stringify(print));
	}

	const { clearTimers } = useIdleStore();

	onMounted(async () => {
		clearTimers();
		await basketStore.startPos(); // pos/open


		console.log("teste1111", paymentObject);
		orderStore.generateOrderId();

		console.log('Order ID: ', orderId.value);

		paymentCC();

		if (window.self === window.top) {
			setTimeout(() => {
				router.push(makePath('/payment-failed'));
			}, 120000);
		}
	});
</script>